import { render, staticRenderFns } from "./tipoExhibicion.vue?vue&type=template&id=26f14705&scoped=true&"
import script from "./tipoExhibicion.vue?vue&type=script&lang=js&"
export * from "./tipoExhibicion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f14705",
  null
  
)

export default component.exports